import { createNodeFromHtmlString } from "./Utils-Html-Rendering.mjs";

// DYNAMIC LOADING SHOWNDOWN
/**
 * Convert Markdown to DOM element
 * @param  {String} text
 * @returns {DOM element}
 */
export function renderMarkdownIntoNode(text, node) {
  console.log("renderMarkdownIntoNode");
  node.classList.add("markdown");
  //WebPack comments : to guarantee that showdown package is accessible from its chunk.js we set his name to 'showndown.[id].js'
  import("showdown")
    .then(({ default: showdown }) => {
      console.log("Lib showdown loaded");
      var parserMarkdown = new showdown.Converter({
        tables: "true",
        simpleLineBreaks: "true",
      });
      var html = parserMarkdown.makeHtml(text).replace(/^<p>|<\/p>$/g, "");
      node.appendChild(createNodeFromHtmlString(html));
    })
    .catch((error) => {
      console.log(error);
      node.appendChild(
        document.createTextNode("Impossible to generate MarkDown")
      );
    });
}

// DYNAMIC LOADING SHOWNDOWN
//AJOUTER CIDESSOUS ENTRE "IMPORT(" et "showdown"
/* webpackChunkName: "showdown" */
/* webpackMode: "lazy" */
/* webpackExports: ["default", "named"] */
/**
 * Convert Markdown to DOM element
 * @param  {String} text
 * @returns {DOM element}
 */
/*
export function parseMarkdown(text) {
  console.log("parseMarkdown");
  var node = document.createElement("span");
  node.classList.add("markdown");
  //WebPack comments : to guarantee that showdown package is accessible from its chunk.js we set his name to 'showndown.[id].js'
  import(
   
    "showdown"
  )
    .then(({ default: showdown }) => {
      console.log("Lib showdown loaded");
      var parserMarkdown = new showdown.Converter({
        tables: "true",
        simpleLineBreaks: "true",
      });
      var html = parserMarkdown.makeHtml(text).replace(/^<p>|<\/p>$/g, "");
      node.appendChild(createNodeFromHtmlString(html));
    })
    .catch((error) => {
      console.log(error);
      node.appendChild(
        document.createTextNode(
          "Impossible to load Markdown lib or generate MarkDown"
        )
      );
    });
  return node;
}
*/
